(function () {
  'use strict';

  function slideSize(track) {
    var item = track.querySelector('.cm-press__item');
    if (!item) return track.clientWidth;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function snapToSlide(track) {
    var size = slideSize(track);
    if (!size) return;
    var index = Math.round(track.scrollLeft / size);
    var maxIndex = Math.max(0, track.querySelectorAll('.cm-press__item').length - 1);
    index = Math.min(Math.max(index, 0), maxIndex);
    track.scrollTo({ left: index * size, behavior: 'smooth' });
  }

  function initCarousel(section) {
    var track = section.querySelector('[data-cm-press-carousel]');
    if (!track || track.dataset.cmPressReady === 'true') return;

    track.dataset.cmPressReady = 'true';

    var bar = section.querySelector('.cm-press__scrollbar');
    var thumb = section.querySelector('.cm-press__scrollbar-thumb');

    function updateScrollbar() {
      if (!bar || !thumb) return;
      var scrollW = track.scrollWidth;
      var clientW = track.clientWidth;

      if (scrollW <= clientW) {
        bar.hidden = true;
        return;
      }

      bar.hidden = false;
      var ratio = clientW / scrollW;
      var thumbW = Math.max(ratio * 100, 15);
      thumb.style.width = thumbW + '%';

      var maxScroll = scrollW - clientW;
      var pct = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      thumb.style.left = pct * (100 - thumbW) + '%';
    }

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('a')) return;

      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      track.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      snapToSlide(track);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    track.addEventListener('scroll', updateScrollbar, { passive: true });
    window.addEventListener('resize', updateScrollbar);
    updateScrollbar();

    if (window.cmBindCarouselScrollbar) {
      window.cmBindCarouselScrollbar(track, bar, thumb);
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.cm-press').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
